import React from 'react';
import './App.css';
import './assets/style';
import Main from './components/Main'

function App() {
  return (
    <Main/>
  );
}

export default App;
